// import
import { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from 'reactstrap';

export const FloatButtonProposal = ({
  toggle,
  verifyIfExistOrganization,
  toggleModalChangeOrg,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {isOpen && (
        <>
          <Button
            onClick={() => toggle()}
            tag={motion.button}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.9 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="btn btn-primary d-flex align-items-center justify-content-center"
            style={{
              width: '200px',
              height: '50px',
              borderRadius: '15px',
              position: 'fixed',
              right: '20px',
              bottom: '130px',
              backgroundColor: '#405189',
              border: 'none',
            }}
          >
            Atualizar Valor
          </Button>

          {verifyIfExistOrganization() && (
            <Button
              onClick={() => toggleModalChangeOrg()}
              tag={motion.button}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.9 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="btn btn-primary d-flex align-items-center justify-content-center"
              style={{
                width: '200px',
                height: '50px',
                borderRadius: '15px',
                position: 'fixed',
                right: '20px',
                bottom: '190px',
                backgroundColor: '#405189',
                border: 'none',
              }}
            >
              Alterar Organização
            </Button>
          )}
        </>
      )}

      <Button
        tag={motion.button}
        onClick={handleButtonClick}
        whileHover={{ scale: 1.01 }}
        whileTap={{ scale: 0.9 }}
        animate={{ rotate: isOpen ? 180 : 0 }}
        transition={{ duration: 0.3 }}
        className="btn btn-primary d-flex align-items-center justify-content-center"
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          position: 'fixed',
          right: '20px',
          bottom: '70px',
          backgroundColor: '#405189',
          border: 'none',
        }}
      >
        {isOpen ? (
          <i
            className="ri-menu-line"
            style={{
              fontSize: '16px',
            }}
          ></i>
        ) : (
          <i
            className="ri-menu-line"
            style={{
              fontSize: '16px',
            }}
          ></i>
        )}
      </Button>
    </>
  );
};
